import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cm-ticketing-boca-default-1',
    templateUrl: './ticket-template-boca-default-1.component.html',
    styleUrls: ['./ticket-template-boca-default-1.component.scss', '../../shared/shared-presets.scss'],
    standalone: false
})
export class TicketTemplateBocaDefault1Component implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
